import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Partner } from '../../master-data-management/partner/entities/Partner.js';
import { WorkshopTrainingAttendance } from './WorkshopTrainingAttendance.js';

/**
 * @entity WorkshopAttendance
 */
@Entity()
export class WorkshopAttendance extends WorkshopTrainingAttendance {
  public static override _class = 'WorkshopAttendance';
  public static override _collectionName = 'workshop-attendance';

  @DataLoadedField(() => Partner, ({ partnerID }) => partnerID)
  public partner: Maybe<Partner>;

  @Field(() => String)
  public partnerID: Maybe<string>;

  @Field(() => Int)
  public attendanceCount: Maybe<number>;
}
